module.exports = __webpack_public_path__ + "assets/img/home-service-price-light-en.ed7fe345.png";